import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
import PhoneOutlinedIcon from '@material-ui/icons/PhoneOutlined';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import PersonOutlinedIcon from '@material-ui/icons/PersonOutlined';
import Hidden from '@material-ui/core/Hidden';
import ContentRow from '../../../../../components/ContentRow/ContentRow.js';

import { getString } from '../../../../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'contactDetails';

class ContactDetailsCard extends React.Component {
  constructor(props) {
    super(props);

    this.handleConfirmed = this.handleConfirmed.bind(this);
  }

  handleConfirmed(event) {
    const { setConfirmedOpen } = this.props;
    setConfirmedOpen();
  }

  render() {
    const {
      classes,
      mobilePhone,
      mobilePhoneName,
      preferredPhone,
      preferredPhoneName,
      email,
    } = this.props;

    return (
      <div className={classes.root}>
        <Grid container spacing={16}>
          <Grid item xs={12}>
            <Hidden lgUp>
              <div className={classes.iconFieldWrapper}>
                <PhoneAndroidIcon className={`${classes.icon} ItemIcon`} />
                <div>
                  <Typography className={classes.label}>
                    {getString(stringsComponent, 'MOBILE_LABEL')}
                  </Typography>
                  <ContentRow>
                    <Typography className={classes.value}>
                      {mobilePhone}
                    </Typography>
                  </ContentRow>
                </div>
              </div>
              <div className={classes.iconFieldWrapper}>
                <PersonOutlinedIcon className={`${classes.icon} ItemIcon`} />
                <div>
                  <Typography className={classes.label}>
                    {getString(stringsComponent, 'MOBILE_NAME_LABEL')}
                  </Typography>
                  <ContentRow>
                    <Typography className={classes.value}>
                      {mobilePhoneName}
                    </Typography>
                  </ContentRow>
                </div>
              </div>
              <div className={classes.iconFieldWrapper}>
                <PhoneOutlinedIcon className={`${classes.icon} ItemIcon`} />
                <div>
                  <Typography className={classes.label}>
                    {getString(stringsComponent, 'PHONE_LABEL')}
                  </Typography>
                  <ContentRow>
                    <Typography className={classes.value}>
                      {preferredPhone}
                    </Typography>
                  </ContentRow>
                </div>
              </div>
              <div className={classes.iconFieldWrapper}>
                <PersonOutlinedIcon className={`${classes.icon} ItemIcon`} />
                <div>
                  <Typography className={classes.label}>
                    {getString(stringsComponent, 'PHONE_NAME_LABEL')}
                  </Typography>
                  <ContentRow>
                    <Typography className={classes.value}>
                      {preferredPhoneName}
                    </Typography>
                  </ContentRow>
                </div>
              </div>
              <div className={classes.iconFieldWrapper}>
                <EmailOutlinedIcon className={`${classes.icon} ItemIcon`} />
                <div>
                  <Typography className={classes.label}>
                    {getString(stringsComponent, 'EMAIL_LABEL')}
                  </Typography>
                  <ContentRow>
                    <Typography className={classes.value}>{email}</Typography>
                  </ContentRow>
                </div>
              </div>
            </Hidden>
            <Hidden mdDown>
              <div className={classes.line}>
                <div className={classes.iconFieldWrapper}>
                  <PhoneAndroidIcon className={`${classes.icon} ItemIcon`} />
                  <div>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'MOBILE_LABEL')}
                    </Typography>
                    <ContentRow>
                      <Typography className={classes.value}>
                        {mobilePhone}
                      </Typography>
                    </ContentRow>
                  </div>
                </div>
                <div className={classes.iconFieldWrapper}>
                  <PersonOutlinedIcon className={`${classes.icon} ItemIcon`} />
                  <div>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'MOBILE_NAME_LABEL')}
                    </Typography>
                    <ContentRow>
                      <Typography className={classes.value}>
                        {mobilePhoneName}
                      </Typography>
                    </ContentRow>
                  </div>
                </div>
              </div>
              <div className={classes.line}>
                <div className={classes.iconFieldWrapper}>
                  <PhoneOutlinedIcon className={`${classes.icon} ItemIcon`} />
                  <div>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'PHONE_LABEL')}
                    </Typography>
                    <ContentRow>
                      <Typography className={classes.value}>
                        {preferredPhone}
                      </Typography>
                    </ContentRow>
                  </div>
                </div>
                <div className={classes.iconFieldWrapper}>
                  <PersonOutlinedIcon className={`${classes.icon} ItemIcon`} />
                  <div>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'PHONE_NAME_LABEL')}
                    </Typography>
                    <ContentRow>
                      <Typography className={classes.value}>
                        {preferredPhoneName}
                      </Typography>
                    </ContentRow>
                  </div>
                </div>
              </div>
              <div className={classes.line}>
                <div className={classes.iconFieldWrapper}>
                  <EmailOutlinedIcon className={`${classes.icon} ItemIcon`} />
                  <div>
                    <Typography className={classes.label}>
                      {getString(stringsComponent, 'EMAIL_LABEL')}
                    </Typography>
                    <ContentRow>
                      <Typography className={classes.value}>{email}</Typography>
                    </ContentRow>
                  </div>
                </div>
              </div>
            </Hidden>
          </Grid>
        </Grid>
      </div>
    );
  }
}

ContactDetailsCard.propTypes = {};

ContactDetailsCard.defaultProps = {};

export default withStyles(styles, { withTheme: true })(ContactDetailsCard);
